import HeaderContainer from './HeadersAndFooters/HeaderContainer';
import HeaderButtonsDetail from './HeadersAndFooters/HeaderButtonsDetail';
import HeaderButtonsFeed from './HeadersAndFooters/HeaderButtonsFeed';
import HeaderButtonsForm from './HeadersAndFooters/HeaderButtonsForm';
import FooterContainer from './HeadersAndFooters/FooterContainer';
import FooterButtonsFeed from './HeadersAndFooters/FooterButtonsFeed';
import FooterButtonsDetail from './HeadersAndFooters/FooterButtonsDetail';
import FooterButtonsForm from './HeadersAndFooters/FooterButtonsForm';
import FooterButtonsList from './HeadersAndFooters/FooterButtonsList';

const HeaderFooterDisplay = ({ isOpen, onClose }) => {
    const mockContext = {
        id: 'locality',
        type: 'location',
        name: 'Example Context'
    };

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 20000,
            padding: '40px'
        }}>
            {/* Modal Container */}
            <div
                className="hf-display-modal"
                style={{
                    background: '#F5F5F5',
                    borderRadius: '12px',
                    maxWidth: '1200px',
                    width: '100%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    position: 'relative',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
                }}
            >
                <style>{`
                    .hf-display-modal div[style*="position: fixed"] {
                        position: relative !important;
                        top: auto !important;
                        left: auto !important;
                        right: auto !important;
                        bottom: auto !important;
                    }
                `}</style>
                {/* Close Button */}
                <div style={{
                    position: 'sticky',
                    top: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: '20px',
                    background: '#F5F5F5',
                    zIndex: 10
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '12px 24px',
                            background: '#024B99',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            transition: 'opacity 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.9'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                        CLOSE
                    </button>
                </div>

                <div style={{ padding: '20px' }}>
                    {/* HEADERS SECTION */}
                    <div style={{ marginBottom: '20px' }}>
                        {/* Header 1: Plain HeaderContainer */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '80px' }}>
                                <div style={{ position: 'relative' }}>
                                    <HeaderContainer />
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                HeaderContainer.jsx (base)
                            </div>
                        </div>

                        {/* Header 2: HeaderContainer + HeaderButtonsDetail */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '80px' }}>
                                <div style={{ position: 'relative' }}>
                                    <HeaderContainer>
                                        <HeaderButtonsDetail
                                            currentContext={mockContext}
                                            onBack={() => console.log('Back clicked')}
                                        />
                                    </HeaderContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                HeaderButtonsDetail.jsx
                            </div>
                        </div>

                        {/* Header 3: HeaderContainer + HeaderButtonsFeed */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '80px' }}>
                                <div style={{ position: 'relative' }}>
                                    <HeaderContainer>
                                        <HeaderButtonsFeed
                                            currentContext={mockContext}
                                            currentMode="news"
                                            selectedGroup={null}
                                            onContextSwitch={() => console.log('Context switch')}
                                        />
                                    </HeaderContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                HeaderButtonsFeed.jsx
                            </div>
                        </div>

                        {/* Header 4: HeaderContainer + HeaderButtonsForm */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '80px' }}>
                                <div style={{ position: 'relative' }}>
                                    <HeaderContainer>
                                        <HeaderButtonsForm
                                            currentContext={mockContext}
                                            onBack={() => console.log('Back clicked')}
                                            headerTitle="Form Example"
                                        />
                                    </HeaderContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                HeaderButtonsForm.jsx
                            </div>
                        </div>

                        {/* Header 5: HeaderContainer + HeaderButtonsForm (Add/Edit pages) */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '80px' }}>
                                <div style={{ position: 'relative' }}>
                                    <HeaderContainer>
                                        <HeaderButtonsForm
                                            currentContext={mockContext}
                                            onBack={() => console.log('Back clicked')}
                                            headerTitle="New Article"
                                        />
                                    </HeaderContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                HeaderButtonsForm.jsx (Add/Edit)
                            </div>
                        </div>
                    </div>

                    {/* FOOTERS SECTION */}
                    <div style={{ marginTop: '20px' }}>

                        {/* Footer 1: Plain FooterContainer */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '120px' }}>
                                <div style={{ position: 'relative' }}>
                                    <FooterContainer viewType="feed" />
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                FooterContainer.jsx (base)
                            </div>
                        </div>

                        {/* Footer 2: FooterContainer + FooterButtonsFeed */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '120px' }}>
                                <div style={{ position: 'relative' }}>
                                    <FooterContainer viewType="feed">
                                        <FooterButtonsFeed
                                            currentContext={mockContext}
                                            viewType="feed"
                                            currentView="feed"
                                        />
                                    </FooterContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                FooterButtonsFeed.jsx
                            </div>
                        </div>

                        {/* Footer 3: FooterContainer + FooterButtonsDetail */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '120px' }}>
                                <div style={{ position: 'relative' }}>
                                    <FooterContainer viewType="feed">
                                        <FooterButtonsDetail
                                            currentContext={mockContext}
                                            viewType="form"
                                            currentView="detail"
                                        />
                                    </FooterContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                FooterButtonsDetail.jsx
                            </div>
                        </div>

                        {/* Footer 4: FooterContainer + FooterButtonsForm */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '120px' }}>
                                <div style={{ position: 'relative' }}>
                                    <FooterContainer viewType="form">
                                        <FooterButtonsForm
                                            onSaveDraft={() => console.log('Save as Draft clicked')}
                                            onCancel={() => console.log('Cancel clicked')}
                                            onCreateAndExit={() => console.log('Create and Exit clicked')}
                                        />
                                    </FooterContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                FooterButtonsForm.jsx
                            </div>
                        </div>

                        {/* Footer 5: FooterContainer + FooterButtonsList */}
                        <div style={{
                            marginBottom: '10px',
                            position: 'relative'
                        }}>
                            <div style={{ position: 'relative', height: '120px' }}>
                                <div style={{ position: 'relative' }}>
                                    <FooterContainer viewType="feed">
                                        <FooterButtonsList showGoToTop={true} />
                                    </FooterContainer>
                                </div>
                            </div>
                            <div style={{
                                textAlign: 'center',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#024B99',
                                marginTop: '4px'
                            }}>
                                FooterButtonsList.jsx
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderFooterDisplay;
